import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  NpAvailableTimesRequest,
  NpAvailableTimesResponse,
} from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { postNpAvailableTimes } from '../../../common/http/data/npTesting'

export const GET_NP_AVAILABLE_TIMES = 'GET_NP_AVAILABLE_TIMES'

export const getNpAvailableTimes = createAsyncThunk<NpAvailableTimesResponse, NpAvailableTimesRequest>(
  GET_NP_AVAILABLE_TIMES,
  async (request, { rejectWithValue }) => {
    try {
      const response = await postNpAvailableTimes(request)
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const CLEAR_NP_AVAILABLE_TIMES = 'CLEAR_NP_AVAILABLE_TIMES'
export const clearNpAvailableTimes = () => ({ type: CLEAR_NP_AVAILABLE_TIMES })

export const GET_NP_AVAILABLE_TIMES_FULFILLED = getNpAvailableTimes.fulfilled.type
export const GET_NP_AVAILABLE_TIMES_PENDING = getNpAvailableTimes.pending.type
export const GET_NP_AVAILABLE_TIMES_REJECTED = getNpAvailableTimes.rejected.type
